import useUserCheckTrial from "@customHooks/fc-payment/use-user-check-trial"
import { COMPLETE_MODULES, FREE_MODULES, LITE_MODULES, PREMIUM_MODULES, PlanModule } from "@interfaces/permission_access"
import { RootState } from "@redux/store"
import { useEffect, useMemo, useState } from "react"
import { useSelector } from "react-redux"

/**
 * @returns Current logged user plan access modules based on the saved plan name
 */
const useUserPlanAccess = () => {
    const [ planAccess, setPlanAccess ] = useState<PlanModule[]>([])
    const { plan, isPremium } = useSelector((state: RootState) => state.session)
    const { isTrial, hasLoaded } = useUserCheckTrial()

    const data = useMemo(() => {
        if(!hasLoaded) return
        if(isTrial)
            return PREMIUM_MODULES
        switch(plan?.name)
        {
            case "FREE":
                return FREE_MODULES
            case "PREMIUM":
                return PREMIUM_MODULES
            case "COMPLETE":
                return COMPLETE_MODULES
            case "LITE":
                return LITE_MODULES
            default:
                if(isPremium)
                    return PREMIUM_MODULES
                return FREE_MODULES
        }
    }, [plan, isPremium, isTrial, hasLoaded])

    useEffect(() => {
        if(!data) return
        setPlanAccess(data)
    }, [data])

    return { planAccess, isTrial, trialInfoLoaded: hasLoaded }
}

export default useUserPlanAccess
